<template>
  <div class="compact-wrapper">
    <BetInfoBar/>
    <PayinToolbar :bettingLocked="bettingLocked" :bettingDisabled="bettingDisabled"/>
  </div>
</template>

<script>
import BetInfoBar from './BetInfoBar';
import PayinToolbar from './PayinToolbar';

export default {
  name: 'CompactLayout',
  components: {
    BetInfoBar,
    PayinToolbar,
  },
  props: {
    bettingLocked: {
      type: Boolean,
      default: false,
    },
    bettingDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .compact-wrapper {
    max-width: 840px;
    width: 100%;
    background-color: #121314;
    margin: 0 auto;
    color: #acacad;
    float: left;
  }
</style>
